export default "__VITE_ASSET__BdN1mcw2__"